import Node from "./Node";

export default class AllCustomersNode extends Node {
    constructor({
        onClick = () => {}
    }) {
        super(onClick)
    }

    templateHtml() {
        return "<div class='node allCustomersNode'>" +
               "  <div class='icon'></div>" +
               "  <div class='title'><%-title%></div>" +
               "</div>";
    }

    messageKeys() {
        return {title: "task.list.all_customers"};
    }

    afterRender() {
        super.afterRender()
        this.renderInitialState()
    }
}


// WEBPACK FOOTER //
// ./web/js/taskManagement/customersProjectsPanel/tree/AllCustomersNode.js